import { render } from "./SideNavbar.vue?vue&type=template&id=765307e2&scoped=true"
import script from "./SideNavbar.vue?vue&type=script&lang=js"
export * from "./SideNavbar.vue?vue&type=script&lang=js"

import "./SideNavbar.vue?vue&type=style&index=0&id=765307e2&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-765307e2"]])

export default __exports__